export class EventDTO {
  id: number;
  name: string;
  description: string;
}
